import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Structures } from '@clavisco/core';
import ICLResponse = Structures.Interfaces.ICLResponse;
import { ILogDocumentDto } from '../interfaces/i-log';
import { IBrowserDownloadFile, IDirectoryItem } from '@clavisco/logs-viewer';


@Injectable({
  providedIn: 'root'
})
export class PhysicalLogsService {
  constructor(private readonly http: HttpClient) {}

   /**
   * Send a request to retrieve the information of the log file that will be download
   * @param pLogDirectoryItemPath Path of the log file that will be downloaded 
   * @returns 
   */
   DownloadLogsDirectoryItem(pLogDirectoryItemPath:string): Observable<ICLResponse<IBrowserDownloadFile>>
   {
     return this.http.get<ICLResponse<IBrowserDownloadFile>>(`api/PhysicalLogs/DownloadLogsDirectoryFile`, {
       params: {filePath: pLogDirectoryItemPath}
     });
   }

   /**
   * Send a request to retrieve the logs from the logs directory
   * @param pStartDate The start date of the date range for which modified log files should be included.
   * @param pEndDate The end date of the date range for which modified log files should be included.
   * @param pLogDirectoryPath Logs directory path that will be requested
   * @returns 
   */
  GetLogsDirectoryItems(pStartDate: Date | string, pEndDate: Date | string, pLogDirectoryPath?: string): Observable<ICLResponse<IDirectoryItem[]>>
  {
    return this.http.get<ICLResponse<IDirectoryItem[]>>(`api/PhysicalLogs/GetLogsDirectoryItems`, {
      params: {
        startDate: new Date(pStartDate).toISOString(),
        endDate: new Date(pEndDate).toISOString(),
        logDirectoryPath: pLogDirectoryPath ?? ''
      }
    });
  }
}
